export default {
  namespaced: true,
  state: {
    showLoadingOverlay: false,
  },
  getters: {
    getLoadingOverlayState: state => {
      return state.showLoadingOverlay;
    },
  },
  actions: {
    setLoadingOverlayVisibility: (context, boolean) => {
      context.commit("setLoadingOverlayVisibility", boolean);
      if (boolean == true) {
        document.querySelector("body").classList.add("overflow-hidden");
      } else {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
    },
  },
  mutations: {
    setLoadingOverlayVisibility: (state, boolean) => {
      state.showLoadingOverlay = boolean;
    },
  },
};
